import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const MyanmarIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getPreRegistrationRedirectionActionImpl() {
      return () => {
        window.location.href = `${window.location.origin}/api/checkHE?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`;
      };
    },
    getIntegrationParametersCheckImpl() {
      return (to) => {
        if (Object.keys(to.query).includes('MSISDN') || to.query.transID) {
          if (!to.query.TPCGID) { // if HE response received
            if (to.query.MSISDN && to.query.MSISDN !== 'null') { // 3G flow
              this.$axios.get(`api/handleHeResponseAndGetRegisterUrl?token=${encodeURIComponent(to.query.MSISDN)}&cid=${to.query.transID}`).then((response) => {
                const redirectionUrl = response.data.data;
                if (!redirectionUrl) { // already sub case
                  this.$axios.get(`api/getStatus?status=0&msisdn=${encodeURIComponent(to.query.MSISDN)}&lang=${this.getLocale}`).then((res) => {
                    if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                      if (res.data.data[0] === 'ALREADY_REGISTERED') {
                        this.storeLoginInfo({
                          token: res.data.data[1],
                          rememberMeParameter: false,
                          username: res.data.data[2],
                        });
                        this.getUserLoginDetails().then(() => {
                          this.updateUserLanguage();
                          this.$router.push('home');
                        });
                      } else { // error case
                        this.$router.push('/');
                      }
                    }
                    this.waitForResponse = false;
                  });
                } else {
                  window.location.href = redirectionUrl; // redirect to partner
                }
              });
            } else { // wifi flow
              this.setCorrelationId({ value: to.query.transID });
              this.$axios.get(`api/getRegisterUrl?msisdn=${to.query.MSISDN}&cid=${to.query.transID}`).then((response) => {
                const redirectionUrl = response.data.data;
                if (!redirectionUrl) { // already sub case
                  this.$router.push('register1'); // or special register 1 for myanmar
                } else {
                  window.location.href = redirectionUrl; // redirect to partner
                }
              });
            }
          } else if (to.query.transID) { // CG response received
            this.$axios.get(`api/getStatus?msisdn=${to.query.MSISDN}&status=${to.query.Reason}&lang=${this.getLocale}&correlationId=${to.query.transID}`).then((res) => {
              if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                if (res.data.data[0] === 'ALREADY_REGISTERED') {
                  this.$gtm.trackEvent({
                    event: 'CompleteRegistration',
                    category: 'MSISDN Registration',
                    action: 'Register 2 registration',
                    label: 'Register 2',
                  });
                  this.storeLoginInfo({
                    token: res.data.data[1],
                    rememberMeParameter: false,
                    username: res.data.data[2],
                  });
                  this.getUserLoginDetails().then(() => {
                    this.updateUserLanguage();
                    this.$router.push('home');
                  });
                } else { // error case
                  this.$router.push('/');
                }
              }
            });
          }
        }
      };
    },
  },
};

export default MyanmarIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/myanmarIntegration.js